import DOMPurify from 'dompurify';

export const sanitizeClueHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'br', 'em', 'i', 'span', 'strong', 'sub', 'sup'],
    ALLOWED_ATTR: [],
  });
};